import React from 'react'
import './customSwitch.css'

const CustomSwitch = ({isChecked,onChange,id,disabled}) => {

    return(
        <div className="form-check form-switch form-switch-lg">
            <input
                disabled={disabled}
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={isChecked}
                onChange={onChange}
            />
            {/* <label className="form-check-label" htmlFor="id">
                {isChecked ? "True" : "False"}
            </label> */}
        </div>
    );
}

export default CustomSwitch